<template>
  <div class="spm-data-container" v-if="$store.state.csiDashboardYearFrom"> 
    <div class="spm-chart">
      <div
        class="d-flex justify-content-center align-items-center chartContainer"
      >
        <highcharts :options="chartOptions"></highcharts>
      </div>
    </div>
    <div class="spm-table">
      <b-table
        striped
        bordered
        no-border-collapse
        responsive
        :items="getItems"
        :fields="fields"
      >
        <template v-slot:thead-top>
          <b-tr>
            <b-th rowspan="3" class="bg-head text-tcenter">Vendor Category</b-th>
            <b-th :colspan="year[1] * 2" class="bg-head text-tcenter" v-for="(year, index) in years" :key="index">{{ year[0] }}</b-th>
          </b-tr>
          <b-tr>
            <b-th colspan="2" class="bg-head text-tcenter" v-for="(month, index) in months" :key="index">{{ convertMonth(month.split('_')[0]) }}</b-th>
          </b-tr>
          <b-tr>
            <b-th class="bg-head text-tcenter" v-for="(item, index) in monthGroups" :key="index">{{ index%2 !== 0 ? 'GEMS' : 'BCE' }}</b-th>
          </b-tr>
        </template>

        <template v-slot:table-colgroup>
			    <col
			      v-for="field in fields"
			      :key="field.key"
			      :rowspan="field.key == 'vendor_category' ? 2 : 1"
			    >
			  </template>


      </b-table>
    </div>
  </div>
</template>
<script>
export default {
  name : 'CsiSummary',
  data() {
    return {
      fields : [
        { key : 'vendor_category', label : '', thClass : 'bg-none'},
      ],
      items : [
        {
          vendor_category : 'Sangat Memuaskan'
        },{
          vendor_category : 'Memuaskan'
        },{
          vendor_category : 'Cukup Memuaskan'
        },{
          vendor_category : 'Tidak Memuaskan'
        },{
          vendor_category : 'Sangat Buruk'
        }
      ],
      years : null,
      months : null,
      tableHead : null,
      monthGroups : null,
      chartOptions: {
        colors: ['#ffd34c', '#a0b376', '#10253f', '#d34c4c', '#ff4c4c'],
        chart: {
          height : '300',
          type: 'column'
        },
        title: {
            text: 'CSI Summary'
        },
        xAxis: {
            categories: [],
            crosshair: true
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Score'
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px"><strong>{point.key}</strong></span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [{
            name: 'Sangat Memuaskan',
            data: [],
        }, {
            name: 'Memuaskan',
            data: [],
        }, {
            name: 'Cukup Memuaskan',
            data: [],
        }, {
            name: 'Tidak Memuaskan',
            data: [],
        },{
            name: 'Sangat Buruk',
            data: [],
        }]
      },
    };
  },
  created(){
      this.chartCategories()
      // this.seriesData()
  },
  computed : {
    getItems : {
      get : function(){
        this.createTable()
        this.seriesData()
        this.chartCategories()
        return this.items
      }
    },
  },
  methods: {
    itemsBefore(){
      this.items = [
        {
          vendor_category : 'Sangat Memuaskan'
        },{
          vendor_category : 'Memuaskan'
        },{
          vendor_category : 'Cukup Memuaskan'
        },{
          vendor_category : 'Tidak Memuaskan'
        },{
          vendor_category : 'Sangat Buruk'
        }
      ]
    },
    fieldsBefore(){
      this.fields = [
        { key : 'vendor_category', label : '', thClass : 'bg-none'},
      ]
    },
    createMonthHead(value){
      let arrMonth = {}
      value && value.forEach(item => {
        item.forEach(list => {
          if(arrMonth[`${list.MONTH}_${list.YEAR}`] == undefined){
            arrMonth[`${list.MONTH}_${list.YEAR}`] = [
              {
                'SERVER' : 'BC',
                'YEAR' : list.YEAR,
                'MONTH' : list.MONTH,
                'sangat_memuaskan' : list.GRADE && list.GRADE == 'SANGAT MEMUASKAN' && list.SERVER == 'BC' ? list.TOTAL : 0,
                'memuaskan' : list.GRADE && list.GRADE == 'MEMUASKAN' && list.SERVER == 'BC' ? list.TOTAL : 0,
                'cukup_memuaskan' : list.GRADE && list.GRADE == 'CUKUP MEMUASKAN' && list.SERVER == 'BC' ? list.TOTAL : 0,
                'tidak_memuaskan' : list.GRADE && list.GRADE == 'TIDAK MEMUASKAN' && list.SERVER == 'BC' ? list.TOTAL : 0,
                'sangat_buruk' : list.GRADE && list.GRADE == 'SANGAT BURUK' && list.SERVER == 'BC' ? list.TOTAL : 0,
              },
              {
                'SERVER' : 'GEMS',
                'YEAR' : list.YEAR,
                'MONTH' : list.MONTH,
                'sangat_memuaskan' : list.GRADE && list.GRADE == 'SANGAT MEMUASKAN' && list.SERVER == 'GEMS' ? list.TOTAL : 0,
                'memuaskan' : list.GRADE && list.GRADE == 'MEMUASKAN' && list.SERVER == 'GEMS' ? list.TOTAL : 0,
                'cukup_memuaskan' : list.GRADE && list.GRADE == 'CUKUP MEMUASKAN' && list.SERVER == 'GEMS' ? list.TOTAL : 0,
                'tidak_memuaskan' : list.GRADE && list.GRADE == 'TIDAK MEMUASKAN' && list.SERVER == 'GEMS' ? list.TOTAL : 0,
                'sangat_buruk' : list.GRADE && list.GRADE == 'SANGAT BURUK' && list.SERVER == 'GEMS' ? list.TOTAL : 0,
              }
            ]
          } else {
            arrMonth[`${list.MONTH}_${list.YEAR}`] = [
              {
                ...arrMonth[`${list.MONTH}_${list.YEAR}`][0],
                'sangat_memuaskan' : list.GRADE && list.GRADE == 'SANGAT MEMUASKAN' && list.SERVER == 'BC' ? list.TOTAL : arrMonth[`${list.MONTH}_${list.YEAR}`][0]['sangat_memuaskan'] ,
                'memuaskan' : list.GRADE && list.GRADE == 'MEMUASKAN' && list.SERVER == 'BC' ? list.TOTAL : arrMonth[`${list.MONTH}_${list.YEAR}`][0]['memuaskan'],
                'cukup_memuaskan' : list.GRADE && list.GRADE == 'CUKUP MEMUASKAN' && list.SERVER == 'BC' ? list.TOTAL : arrMonth[`${list.MONTH}_${list.YEAR}`][0]['cukup_memuaskan'],
                'tidak_memuaskan' : list.GRADE && list.GRADE == 'TIDAK MEMUASKAN' && list.SERVER == 'BC' ? list.TOTAL : arrMonth[`${list.MONTH}_${list.YEAR}`][0]['tidak_memuaskan'],
                'sangat_buruk' : list.GRADE && list.GRADE == 'SANGAT BURUK' && list.SERVER == 'BC' ? list.TOTAL : arrMonth[`${list.MONTH}_${list.YEAR}`][0]['sangat_buruk'],
              },
              {
                ...arrMonth[`${list.MONTH}_${list.YEAR}`][1],
                'SERVER' : list.SERVER == 'GEMS' ? list.SERVER : arrMonth[`${list.MONTH}_${list.YEAR}`]['SERVER'],
                'sangat_memuaskan' : list.GRADE && list.GRADE == 'SANGAT MEMUASKAN' && list.SERVER == 'GEMS' ? list.TOTAL : arrMonth[`${list.MONTH}_${list.YEAR}`][1]['sangat_memuaskan'],
                'memuaskan' : list.GRADE && list.GRADE == 'MEMUASKAN' && list.SERVER == 'GEMS' ? list.TOTAL : arrMonth[`${list.MONTH}_${list.YEAR}`][1]['memuaskan'],
                'cukup_memuaskan' : list.GRADE && list.GRADE == 'CUKUP MEMUASKAN' && list.SERVER == 'GEMS' ? list.TOTAL : arrMonth[`${list.MONTH}_${list.YEAR}`][1]['cukup_memuaskan'],
                'tidak_memuaskan' : list.GRADE && list.GRADE == 'TIDAK MEMUASKAN' && list.SERVER == 'GEMS' ? list.TOTAL : arrMonth[`${list.MONTH}_${list.YEAR}`][1]['tidak_memuaskan'],
                'sangat_buruk' : list.GRADE && list.GRADE == 'SANGAT BURUK' && list.SERVER == 'GEMS' ? list.TOTAL : arrMonth[`${list.MONTH}_${list.YEAR}`][1]['sangat_buruk'],
              }
            ]
          }
        })
      })
      this.tableHead = arrMonth
      this.countMonthAndYear(Object.values(arrMonth))
      this.months = Object.keys(arrMonth)
      this.monthGroups = [...this.months, ...this.months]
    },
    countMonthAndYear(value){
      let createObjYear = {}
       value && value.forEach(list => {
         if(createObjYear[`${list[0]['YEAR']}`] == undefined){
           createObjYear[`${list[0]['YEAR']}`] = 1
         } else {
           createObjYear[`${list[0]['YEAR']}`] += 1
         }
       })
       this.years = Object.entries(createObjYear)
    },
    createTableHead(summary){
      const self = this
      let arrYear = {}
      summary && summary.map(list => {
        if(arrYear[list.YEAR] == undefined){
          arrYear[list.YEAR] = [{
            'SERVER' : list.SERVER,
            'MONTH' : list.MONTH,
            'TOTAL' : list.TOTAL,
            'GRADE' : list.GRADE,
            'YEAR' : list.YEAR,
          }]
        } else {
          arrYear[list.YEAR].push({
            'SERVER' : list.SERVER,
            'MONTH' : list.MONTH,
            'TOTAL' : list.TOTAL,
            'GRADE' : list.GRADE,
            'YEAR' : list.YEAR,
          })
        }
      })

      // self.years = Object.entries(arrYear)
      this.createMonthHead(Object.values(arrYear))
    },
    createTable(){
      const self = this
      
      const summary = self.$store.state.csiDashboardSummary
      const yearFrom = self.$store.state.csiDashboardYearFrom
      const yearTo = self.$store.state.csiDashboardTo
      const monthFrom = self.$store.state.csiDashboardMonthFrom
      const monthTo = self.$store.state.csiDashboardMonthTo
      self.itemsBefore()
      self.fieldsBefore()
      self.createTableHead(summary)

      self.tableHead && Object.entries(self.tableHead).forEach(item => {
        self.items[0] = {
          ...self.items[0],
          [`bce_${item[0]}`] : item[1][0] && item[1][0].sangat_memuaskan ,
          [`gems_${item[0]}`] : item[1][1] && item[1][1].sangat_memuaskan 
        }
        self.items[1] = {
          ...self.items[1],
          [`bce_${item[0]}`] : item[1][0] && item[1][0].memuaskan ,
          [`gems_${item[0]}`] : item[1][1] && item[1][1].memuaskan  
        }
        self.items[2] = {
          ...self.items[2],
          [`bce_${item[0]}`] : item[1][0] && item[1][0].cukup_memuaskan ,
          [`gems_${item[0]}`] : item[1][1] && item[1][1].cukup_memuaskan  
        }
        self.items[3] = {
          ...self.items[3],
          [`bce_${item[0]}`] : item[1][0] && item[1][0].tidak_memuaskan ,
          [`gems_${item[0]}`] : item[1][1] && item[1][1].tidak_memuaskan  
        }
        self.items[4] = {
          ...self.items[4],
          [`bce_${item[0]}`] : item[1][0] && item[1][0].sangat_buruk ,
          [`gems_${item[0]}`] : item[1][1] && item[1][1].sangat_buruk  
        }
        
        self.fields = [
          ...self.fields,
          { key : `bce_${item[0]}`, label : '', thClass : 'bg-none'},
          { key : `gems_${item[0]}`, label : '', thClass : 'bg-none'},
        ]
      })
    },
    chartCategories() {
      const self = this
      const yearFrom = self.$store.state.csiDashboardYearFrom
      const yearTo = self.$store.state.csiDashboardTo
      const dateFormat =  { day: 'numeric', month: 'short', year: 'numeric' }

      let createCategories = []
      self.tableHead && Object.entries(self.tableHead).forEach(item => {
        createCategories.push(`${self.convertMonth(item[0].split('_')[0])} ${item[0].split('_')[1]} BCE`, `${self.convertMonth(item[0].split('_')[0])} ${item[0].split('_')[1]} GEMS`)
      })

      self.chartOptions.xAxis.categories = createCategories
    },
    seriesData() {
      const self = this
      const items = self.items
      const summary = self.$store.state.csiDashboardSummary
      const yearFrom = self.$store.state.csiDashboardYearFrom
      const yearTo = self.$store.state.csiDashboardTo

      let series0 = []
      let series1 = []
      let series2 = []
      let series3 = []
      let series4 = []
      for(let i in items){
        let newItems = Object.values(items[i])
        let removed = newItems.shift()
        self.chartOptions.series[i].data = newItems
      }

    },
    convertMonth(value){
      switch (value) {
        case '1':
          return 'Jan'
          break;
        case '2':
          return 'Feb'
          break;
        case '3':
          return 'Mar'
          break;
        case '4':
          return 'Apr'
          break;
        case '5':
          return 'Mei'
          break;
        case '6':
          return 'Jun'
          break;
        case '7':
          return 'Jul'
          break;
        case '8':
          return 'Agt'
          break;
        case '9':
          return 'Sep'
          break;
        case '10':
          return 'Okt'
          break;
        case '11':
          return 'Nov'
          break;
        case '12':
          return 'Des'
          break;
      
        default:
          break;
      }
    }
  },
};
</script>
<style lang="scss">
  @import "~/assets/scss/components/dashboard.scss";
</style>
